<!-- This component is close to https://ob1.orange.fr/#example/alerte.html but using label instead of span. -->

<template>
  <div class="alert-container alert-container-sm alert-danger invalid-feedback d-block">
    <p class="alert">
      <span
        class="alert-icon"
        aria-hidden="true" />
      <label
        id="promotional-code-invalid-feedback"
        for="promotional-code-input"
        class="ob1-alert-title">{{ message }}</label>
    </p>
  </div>
</template>

<script>
export default {
  name: 'PromotionalCodeError',
  props: {
    message: {
      type: String,
      required: true
    }
  }
}
</script>
